import { QueryClient } from "@tanstack/react-query";
import { ApiError, NetworkError } from "@/shared/api/errors";

/**
 * Server-state cache for the whole app.
 * - Retries only failures that can heal by themselves (network, 5xx), never 4xx.
 * - Refetches when the tab regains focus: a tab left open in the background catches up with
 *   changes made elsewhere (ADR-0004 in the platform repo — no live sync at launch).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        const transient =
          error instanceof NetworkError || (error instanceof ApiError && error.status >= 500);
        return transient && failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
